import { Tab, Tabs } from 'material-ui/Tabs';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import classNames from 'classnames';
import AuthenticationProviderType from '../../services/enums/authenticationProviderType';
import ChangePasswordForm from '../account/forgotPasswordFlow/changePasswordForm';
import TwoFAForm from '../account/twoFA';
import EditUserProfileContainer from '../users/editUserProfile/editUserProfileContainer';
import ScreenLoaderContainer from '../portal/controls/screenLoaderContainer';
import styles from '../../styles/users/user.scss';

@inject('translationsStore', 'editUserProfileStore', 'authenticationProvidersStore', 'twoFAStore') @observer
export default class LoggedInUserTabs extends Component {

    state = {
        selectedTabId: -1
    };

    handleActive = (tab) => {

        this.setState({
            selectedTabId: tab.props['value']
        });
    };

    handleTabChange = (e) => {
        this.props.twoFAStore.changeStep(this.props.twoFAStore.twoFactorSteps.authoptions);
    };

    componentDidMount() {

        this.props.editUserProfileStore.getUserProfile().then((user) => {
            this.props.authenticationProvidersStore.getAllAuthenticationProviders().then((providers) => {

                const editUserProfileStore = this.props.editUserProfileStore;

                let provider = providers.filter(p => p.id == user.authenticationProviderId)[0];
                
                this.setState({
                    isLocalUser: provider.providerType.toLowerCase() === AuthenticationProviderType.Application.toLowerCase(),
                    isLocalUserSet: true
                });
            })
        });

        this.setState({
            selectedTabId: 1
        });
    }

    render() {

        if (!this.state.isLocalUserSet || !this.props.editUserProfileStore.userLoaded) {
            return <ScreenLoaderContainer />;
        }
        const generalTitle = this.props.translationsStore.translate('GENERAL');

        const passwordTitle = this.props.translationsStore.translate('PASSWORD');

        const twoFATitle = this.props.translationsStore.translate('TWO-FACTOR-AUTHENTICATION');

        const tabStyleProps = {
            className: `tab-dialog`,
            buttonStyle: { color: '#372f51' },
            style: { backgroundColor: '#fff' }
        };

	    const changePasswordComponent = <div className={classNames(styles.changePasswordTab)}>
		                                    <ChangePasswordForm
			                                    header={this.props.translationsStore.translate('MY_PROFILE_CHANGE_PASSWORD')}
			                                    oldPasswordText={this.props.translationsStore.translate('CURRENT_PASSWORD')}
			                                    isMyProfileMode={true}/>
        </div>;

        const twoFAComponent = <div className={classNames(styles.changePasswordTab)}>
            <TwoFAForm
                header={this.props.translationsStore.translate('TWOFACTOR_HEADER')}
                oldPasswordText={this.props.translationsStore.translate('CURRENT_PASSWORD')}
                isMyProfileMode={true} />
        </div>;

        const editUserProfileContainer = <div><EditUserProfileContainer data-cy='user-profile-container' /></div>;
        
        const tabs = [];
        tabs.push({
            id: 1,
            title: generalTitle,
            component: editUserProfileContainer,
            icon: null
        });

        if (this.state.isLocalUser) {
            tabs.push(
                {
                    id: 2,
                    title: passwordTitle,
                    component: changePasswordComponent,
                    icon: null
                }
            );

            tabs.push(
                {
                    id: 3,
                    title: twoFATitle,
                    component: twoFAComponent,
                    icon: null
                }
            );
        }

        return (
            <div className={classNames(styles.userProfileTabContainer)}>
                <div className={classNames(styles.userProfileContainer)} data-cy='user-profile-screen'>

                    <div className={classNames(styles.userProfileTitle)}>
                        {this.props.translationsStore.translate('MY_PROFILE')}: {this.props.editUserProfileStore.profileValues.userName}
                    </div>

                    <Tabs className={classNames(styles.tabsDialog)} onChange={this.handleTabChange} contentContainerClassName={classNames(styles.tabsDialogContentWrapper)}>
                        {
                            tabs.map((tab, index) => {
                                return <Tab
                                    key={index} {...tabStyleProps}
                                    value={tab.id}
                                    className={`tab-dialog${this.state.selectedTabId == tab.id ? ' selected' : ''}`}
                                    style={{ backgroundColor: '#fff' }}
                                    label={tab.title}
                                    icon={tab.icon}
                                    onActive={this.handleActive}>
                                    <div>
                                        {tab.component}
                                    </div>
                                </Tab>
                            })
                        }
                    </Tabs>
                </div>
            </div>
        );
    };
}


// WEBPACK FOOTER //
// ./src/components/myProfile/loggedInUserTabs.jsx